import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personBlackWhiteList/task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/personBlackWhiteList/task/check',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/personBlackWhiteList/revoke',
    method: 'post',
    data,
  })
}
